import * as React from 'react';
import { ErrorBoundary as ErrorBoundaryProvider } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  return <ErrorBoundaryProvider fallbackRender={ErrorFallback}>{children}</ErrorBoundaryProvider>;
};
